import React, { useEffect, useState } from "react";
import './EditPropertyModel.css';
import DocumentPreview from "../Common/DocumentPreview";

const EditPropertyModal = ({
    showEditModal,
    setShowEditModal,
    PropertyDetails,
    page222
}) => {
    const [page, setPages] = useState(page222);
    const [errors, setErrors] = useState({});

    const handleNext = () => {
        const newErrors = {};
        if (!PropertyDetails.pincode || !/^\d{6}$/.test(PropertyDetails.pincode)) {
            newErrors.pincode = "Pincode must be exactly 6 digits";
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setTimeout(() => setErrors({}), 2000);
        } else {
            setPages('page2');
        }
    };
    useEffect(() => {
        console.log(PropertyDetails, 'PropertyDetails');
    }, [PropertyDetails]);
    if (!showEditModal) return null;

    return (
        <div className="edit-modal-overlay">
            <div className="edit-modal-container">
                <div className="edit-modal-header">
                    <h4>View Property</h4>
                    <span className="edit-modal-close" onClick={() => setShowEditModal(false)}>&times;</span>
                </div>
                <hr />
                <div className="edit-modal-body">
                    {page === 'page1' ? (
                        <div className="edit-form">
                            {[
                                { label: "Pincode", name: "pincode", placeholder: "Enter pincode" },
                                { label: "Address", name: "address", placeholder: "Enter address" },
                                { label: "City", name: "city", placeholder: "Enter city" },
                                { label: "State", name: "state", placeholder: "Enter state" },
                                { label: "Sale Deed Submission Date", name: "saleDeedSubmissionDate", placeholder: "" },
                            ].map((field, i) => (
                                <div className="edit-form-group" key={i}>
                                    <label>{field.label}</label>
                                    <input
                                        type="text"
                                        name={field.name}
                                        value={PropertyDetails[field.name]}
                                        placeholder={field.placeholder}
                                        disabled={true}
                                    />
                                    {errors[field.name] && <p className="edit-error-text">{errors[field.name]}</p>}
                                </div>
                            ))}

                            <div className="edit-form-group">
                                <label>Property Type</label>
                                <select
                                    name="propertyType"
                                    disabled={true}
                                    value={PropertyDetails.propertyType}
                                >
                                    <option value="agriculture">Agriculture</option>
                                    <option value="general">General</option>
                                </select>
                            </div>

                            {PropertyDetails.Declaration === true || PropertyDetails.Declaration === "true" || PropertyDetails.declaration === true || PropertyDetails.declaration === "true" ? (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="checkbox-box-verification">
                                            <input type="checkbox" checked={true} readOnly className="verification-checkbox" />
                                            <p className="verification-text">I verify that full payment to the seller has been processed.</p>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="col-md-3">
                                    <label>Sale Agreement</label>
                                    <DocumentPreview
                                        url={PropertyDetails.sale_Aggrement}
                                        title="Sale Agreement"
                                        showActions={true}
                                        style={{
                                            height: '150px'
                                        }}
                                    />
                                </div>
                                {!(PropertyDetails.Declaration === true || PropertyDetails.Declaration === "true" || PropertyDetails.declaration === true || PropertyDetails.declaration === "true") && (
                                    <div className="col-md-3">
                                        <label>Declaration</label>
                                        <DocumentPreview
                                            url={PropertyDetails.Declaration || PropertyDetails.declaration}
                                            title="Declaration"
                                            showActions={true}
                                            style={{
                                                height: '150px'
                                            }}
                                        />
                                    </div>
                                )}
                                <div className="col-md-3">
                                    <label>Sale Deed Document</label><br /><br /><br />
                                    {PropertyDetails.saleDeedUploaded !== '' ? <DocumentPreview
                                        style={{
                                            height: '150px'
                                        }}
                                        url={PropertyDetails.saleDeedUploaded}
                                        title="Sale Deed"
                                        showActions={true}
                                    /> : <p className="error">Saledeed not uploaded</p>}

                                </div>
                            </div>
                            <div className="row setCenter">
                                <div className="col-md-3">
                                    <button className="btn-prev" onClick={handleNext}>Next Page</button>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="edit-documents-section">
                            <div className="document-grid row">
                                {/* <h4>{PropertyDetails?.documents[0]?.date ? 'Date Format':PropertyDetails?.documents[0]?.categories?'Regular Format':'Department Wise Format'}</h4> */}
                                {PropertyDetails?.documents[0]?.date && PropertyDetails?.documents[0]?.date?.map((doc, index) => (
                                    <div className="col-md-3 col-sm-6 mb-4" key={index}>
                                        <div className="document-card">
                                            <p className="document-date"><strong>Date:</strong> {doc.manualDate}</p>
                                            <DocumentPreview
                                                url={doc.data}
                                                title={`Document ${index}`}
                                                className="document-preview"
                                                showActions={true}
                                            />
                                            <a
                                                href={doc.data}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="document-download-link"
                                            >
                                                🔽 View Full Document
                                            </a>
                                        </div>
                                    </div>
                                ))}
                                {PropertyDetails?.documents?.[0]?.categories &&
                                    PropertyDetails.documents[0].categories.map((category, catIndex) => {
                                        const doc = PropertyDetails.documents[0]; // single doc object
                                        const fileData = doc.files?.[category]?.[0]; // first file
                                        const description = doc.fields?.descriptions?.[category];

                                        return (
                                            <div className="col-md-4 col-sm-6 mb-4" key={`cat-${catIndex}`}>
                                                <div className="document-card">
                                                    <h6 className="document-category">{category}</h6>
                                                    <p className="document-desc">{description}</p>
                                                    {/* <p className="document-date">
                                                        <strong>Date:</strong> {createdAt}
                                                    </p> */}

                                                    {fileData?.file && (
                                                        <DocumentPreview
                                                            url={fileData.file}
                                                            className="document-preview"
                                                            title={fileData.name}
                                                            showActions={true}
                                                        />
                                                    )}

                                                    <a
                                                        href={fileData?.file}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="document-download-link"
                                                    >
                                                        🔽 {fileData?.name || "Download Document"}
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })}

                                {PropertyDetails?.documents?.[0]?.regularcategories &&
                                    PropertyDetails.documents[0].regularcategories.map((category, catIndex) => {
                                        const doc = PropertyDetails.documents[0]; // same single doc object
                                        const key = category.replace(/\s+/g, '_'); // convert spaces to underscores
                                        const fileObj = doc.files?.[key]?.[0];

                                        return (
                                            <div className="col-md-4 col-sm-6 mb-4" key={`reg-${catIndex}`}>
                                                <div className="document-card">
                                                    <h6 className="document-category">{category}</h6>
                                                    {/* <p className="document-date">
                                                        <strong>Date:</strong> {createdAt}
                                                    </p> */}

                                                    {fileObj?.data && (
                                                        <DocumentPreview
                                                            url={fileObj.data}
                                                            className="document-preview"
                                                            title={`Document ${key}`}
                                                            showActions={true}
                                                        />
                                                    )}

                                                    <a
                                                        href={fileObj?.data}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="document-download-link"
                                                    >
                                                        🔽 View Full Document
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <button className="btn-prev" onClick={() => setPages('page1')}>Previous</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EditPropertyModal;
